<template>
  <div class="emptySelection">
    <div class="emptySelection__image">
      <svg width="269px" height="142px" viewBox="0 0 269 142" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="listing-list-item" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="lifestyle_page_empty_list-1440" transform="translate(-470.000000, -599.000000)">
                    <g id="list_empty" transform="translate(470.000000, 599.000000)">
                        <ellipse id="Oval" fill="#EFEAED" fill-rule="nonzero" opacity="0.8" cx="133.768362" cy="138" rx="47" ry="4"></ellipse>
                        <polygon id="Path-2" fill-opacity="0.03" fill="#FF2D55" points="189.220339 18.1920904 240.88299 18.1920904 231.629978 32.1920904 253.220339 32.1920904 231.629978 46.1920904 240.88299 108.19209 189.220339 108.19209"></polygon>
                        <polygon id="Path-2" fill-opacity="0.05" fill="#FF2D55" points="189 22 234.204819 22 224.108434 35.7555556 245 34.7555556 225.108434 45.5111111 234.204819 104 189 104"></polygon>
                        <polygon id="Path-2" fill-opacity="0.03" fill="#FF2D55" transform="translate(48.000000, 63.192090) scale(-1, 1) translate(-48.000000, -63.192090) " points="16 18.1920904 67.6626506 18.1920904 58.4096386 32.1920904 80 32.1920904 58.4096386 46.1920904 67.6626506 108.19209 16 108.19209"></polygon>
                        <polygon id="Path-2" fill-opacity="0.05" fill="#FF2D55" transform="translate(51.000000, 63.000000) scale(-1, 1) translate(-51.000000, -63.000000) " points="23 22 68.2048193 22 59.1084337 34.7555556 79 34.7555556 59.1084337 46.5111111 68.2048193 104 23 104"></polygon>
                        <g id="Group-13" transform="translate(76.485876, 0.000000)">
                            <rect id="Rectangle-10" fill="#EE7993" x="0" y="0" width="115.480226" height="125.762712" rx="4"></rect>
                            <rect id="Rectangle-10" fill="#FAFAFA" x="3.16384181" y="23.7288136" width="109.152542" height="98.8700565" rx="4"></rect>
                            <circle id="Oval-2" fill="#FFFFFF" cx="9.88700565" cy="12.259887" r="3.55932203"></circle>
                            <circle id="Oval-2" fill="#FFFFFF" cx="20.1694915" cy="12.259887" r="3.55932203"></circle>
                            <circle id="Oval-2" fill="#FFFFFF" cx="30.4519774" cy="12.259887" r="3.55932203"></circle>
                        </g>
                        <g id="Group-7" transform="translate(112.079096, 49.039548)" fill="#EE7993">
                            <rect id="Rectangle-11" stroke="#979797" x="13.1553672" y="13.1553672" width="17.9830508" height="2.16384181"></rect>
                            <circle id="Oval-3" cx="3.16384181" cy="3.16384181" r="3.16384181"></circle>
                            <circle id="Oval-3" cx="41.1299435" cy="3.16384181" r="3.16384181"></circle>
                        </g>
                        <circle id="Oval-4" stroke="#A8E4FF" stroke-width="4" fill="#FFFFFF" cx="232.305085" cy="49.2033898" r="6.32768362"></circle>
                        <circle id="Oval-4" fill="#FFFFFF" opacity="0.649274554" cx="205.327684" cy="74.3276836" r="6.32768362"></circle>
                        <circle id="Oval-4" stroke="#A8E4FF" stroke-width="2" fill="#FFFFFF" cx="207.785311" cy="120.225989" r="3.16384181"></circle>
                        <circle id="Oval-4" stroke="#EE7993" stroke-width="2" fill="#FFFFFF" cx="225.581921" cy="120.581921" r="1.5819209"></circle>
                        <circle id="Oval-4" stroke="#EE7993" stroke-width="2" fill="#FFFFFF" cx="43.5819209" cy="120.581921" r="1.5819209"></circle>
                        <circle id="Oval-4" stroke="#A8E4FF" stroke-width="2" fill="#FFFFFF" cx="60.6666667" cy="120.225989" r="3.16384181"></circle>
                        <circle id="Oval-4" stroke="#A8E4FF" stroke-width="4" fill="#FFFFFF" cx="35.3559322" cy="50.2033898" r="6.32768362"></circle>
                        <circle id="Oval-4" fill="#FFFFFF" opacity="0.649274554" cx="62.3276836" cy="74.3276836" r="6.32768362"></circle>
                        <g id="Group-11" transform="translate(244.960452, 92.542373)" fill="#FFB54C">
                            <rect id="Rectangle-12" transform="translate(3.954802, 3.954802) rotate(45.000000) translate(-3.954802, -3.954802) " x="-0.790960452" y="3.16384181" width="9.49152542" height="1.5819209" rx="0.790960452"></rect>
                            <rect id="Rectangle-12" transform="translate(3.954802, 3.954802) rotate(-45.000000) translate(-3.954802, -3.954802) " x="-0.790960452" y="3.16384181" width="9.49152542" height="1.5819209" rx="0.790960452"></rect>
                        </g>
                        <g id="Group-11" transform="translate(265.960452, 84.542373) rotate(45.000000) translate(-265.960452, -84.542373) translate(263.960452, 82.542373)" fill="#D8D8D8">
                            <rect id="Rectangle-12" transform="translate(2.000000, 2.000000) rotate(45.000000) translate(-2.000000, -2.000000) " x="-0.4" y="1.6" width="4.8" height="1" rx="0.5"></rect>
                            <rect id="Rectangle-12" transform="translate(2.000000, 2.000000) rotate(-45.000000) translate(-2.000000, -2.000000) " x="-0.4" y="1.6" width="4.8" height="1" rx="0.5"></rect>
                        </g>
                        <g id="Group-11" transform="translate(2.960452, 84.542373) rotate(45.000000) translate(-2.960452, -84.542373) translate(0.960452, 82.542373)" fill="#D8D8D8">
                            <rect id="Rectangle-12" transform="translate(2.000000, 2.000000) rotate(45.000000) translate(-2.000000, -2.000000) " x="-0.4" y="1.6" width="4.8" height="1" rx="0.5"></rect>
                            <rect id="Rectangle-12" transform="translate(2.000000, 2.000000) rotate(-45.000000) translate(-2.000000, -2.000000) " x="-0.4" y="1.6" width="4.8" height="1" rx="0.5"></rect>
                        </g>
                        <g id="Group-11" transform="translate(14.790960, 92.542373)" fill="#FFB54C">
                            <rect id="Rectangle-12" transform="translate(3.954802, 3.954802) rotate(45.000000) translate(-3.954802, -3.954802) " x="-0.790960452" y="3.16384181" width="9.49152542" height="1.5819209" rx="0.790960452"></rect>
                            <rect id="Rectangle-12" transform="translate(3.954802, 3.954802) rotate(-45.000000) translate(-3.954802, -3.954802) " x="-0.790960452" y="3.16384181" width="9.49152542" height="1.5819209" rx="0.790960452"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    </div>
    <div class="emptySelection__title">
      <h4 v-if="title" class="regular-font">{{title}}</h4>
      <h4 v-else class="regular-font">Nothing to show right now!</h4>
    </div>
    <div class="emptySelection__description">
      <p v-if="subtitle" class="small-font">{{subtitle}}</p>
      <p v-else class="small-font">Please modify your filter or change your search</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'adx-empty-selection',
  components: {

  },
  props: {
    title: {
      required: false
    },
    subtitle: {
      required: false
    },
  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>